import {z} from 'zod';
import {MAX_ANSWER_LENGTH, MAX_COMMENT_LENGTH, MAX_QUESTION_LENGTH, MIN_ANSWER_LENGTH, MIN_QUESTION_LENGTH} from './constant';

export const answerValidator = z.object({
    text: z.string().min(MIN_ANSWER_LENGTH, `answer;min;${MIN_ANSWER_LENGTH}`).max(MAX_ANSWER_LENGTH, `answer;max;${MAX_ANSWER_LENGTH}`),
    comment: z.string().max(MAX_COMMENT_LENGTH, `comment;max;${MAX_COMMENT_LENGTH}`),
});

export const questionBaseValidator = z.object({
    question: z
        .string()
        .min(MIN_QUESTION_LENGTH, `question;min;${MIN_QUESTION_LENGTH}`)
        .max(MAX_QUESTION_LENGTH, `question;max;${MAX_QUESTION_LENGTH}`),
    answers: z.array(answerValidator).optional(),
});
